export enum UserRole {
  Ministry = 1,
  School = 2
}

export default UserRole;
